<template>
  <div class="container-fluid">
    <div class="block-header">
      <div class="row clearfix breadcrumb-margin-lg">
        <div class="col-7 col-lg-6 col-md-6 col-sm-7 mt-1">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="#">Master</a></li>
              <li class="breadcrumb-item active" aria-current="page">Helper Type</li>
            </ol>
          </nav>
        </div>
        <div class="col-5 col-lg-6 col-md-6 col-sm-5">
          <a
            @click="openDialog()"
            class="btn float-right btn-info text-light"
            title="Add Helper Type"
            ><i class="fa fa-plus pr-1"></i>Add Type</a
          >
        </div>
      </div>
    </div>

    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card body-margin">
          <!-- <div class="header">
            <ul class="header-dropdown dropdown">
               <li>
                  <a href="javascript:void(0);" class="full-screen"
                    ><i class="icon-frame"></i
                  ></a>
                </li> 
            </ul>
          </div> -->

          <div class="body">
            <v-app>
              <div>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    outlined
                    dense
                    hide-details
                    class="search-field br-radius"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12">
                  <v-card class="mx-auto m-fix" tile>
                    <v-toolbar flat>
                      <v-spacer></v-spacer>

                      <v-dialog v-model="dialog" max-width="500px">
                        <v-card>
                          <v-form v-model="isFormValid">
                            <v-card-title class="custom-title theme-backcolor">
                              <span class="fs text-white">{{ formTitle }}</span>
                            </v-card-title>

                            <v-card-text>
                              <v-container>
                                <v-row>
                                  <v-col cols="12" class="mt-6">
                                    <label class="text-muted">Helper Title</label>
                                    <v-text-field
                                      required
                                      outlined
                                      dense
                                      class="mt-n8"
                                      v-model="helper_types.helpertype_title"
                                      :error-messages="errors.helpertype_title"
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>

                            <v-card-actions class="mt-n3">
                              <v-spacer></v-spacer>

                              <v-btn class="btn-danger text-white" text @click="close">
                                Cancel
                              </v-btn>

                              <v-btn
                                class="btn-primary theme-backcolor text-white"
                                text
                                @click="save"
                                :disabled="!isFormValid"
                              >
                                Save
                              </v-btn>
                            </v-card-actions>
                          </v-form>
                        </v-card>

                        <v-overlay :value="overlay">
                          <v-progress-circular indeterminate size="64"></v-progress-circular>
                        </v-overlay>
                      </v-dialog>

                      <v-dialog v-model="dialogDelete" max-width="500px">
                        <v-card>
                          <v-card-title class="headline">
                            Are you sure you want to delete this item?
                          </v-card-title>

                          <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn color="blue darken-1" text @click="closeDelete"> Cancel </v-btn>

                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">
                              OK
                            </v-btn>

                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>

                    <ag-grid-vue
                      class="ag-theme-alpine"
                      style="width: 100%; height: auto"
                      :columnDefs="columnDefs"
                      :rowData="helper_types"
                      :gridOptions="gridOptions"
                      :pagination="false"
                      :domLayout="'autoHeight'"
                      @grid-ready="onGridReady"
                    >
                    </ag-grid-vue>

                    <v-col cols="12" sm="12">
                      <v-row>
                        <v-col cols="4" sm="3">
                          <v-select
                            attach=""
                            v-model="pageSize"
                            :items="pageSizes"
                            :menu-props="{ bottom: true, offsetY: true }"
                            label="Items per Page"
                            @change="handlePageSizeChange"
                          ></v-select>
                        </v-col>

                        <v-col cols="12" sm="9">
                          <v-pagination
                            v-model="currentPage"
                            :length="lastPage"
                            @input="handlePageChange"
                            total-visible="10"
                          ></v-pagination>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-card>
                </v-col>
              </div>
            </v-app>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataService from '../../../dataservice';
import { AgGridVue } from 'ag-grid-vue';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
export default {
  components: {
    AgGridVue,
  },
  data() {
    return {
      errors: '',
      dialog: false,
      loading: true,
      isFormValid: false,
      totalItems: 0,
      currentPage: 1,
      editedIndex: -1,
      dialogDelete: false,
      lastPage: 0,
      overlay: false,
      search: '',
      helper_types: [],
      defaultItem: {
        helpertype_title: '',
      },
      pageSize: 10,
      pageSizes: [10, 25, 50, 100],
      headers: [
        { text: 'Sr. No.', value: 'index' },
        // { text: "ID", value: "helpertype_id" },
        { text: 'Actions', value: 'actions', sortable: false },
        { text: 'Helper Type Name', value: 'helpertype_title' },
        { text: 'Active Status', value: 'helpertype_isactive' },
      ],

      gridApi: null,
      columnDefs: [
        {
          headerName: 'Sr. No.',
          valueGetter: params => {
            return params.node.rowIndex + 1 + (this.currentPage - 1) * this.pageSize;
          },
          width: 120,
        },
        {
          headerName: 'Actions',
          field: 'actions',
          width: 300,
          cellRenderer: params => {
            const button = document.createElement('button');

            button.innerHTML = `Action <i class="fa fa-chevron-down"></i>`;
            button.classList.add('btn', 'btn-primary');

            button.addEventListener('click', e => {
              e.stopPropagation();

              const oldMenu = document.getElementById('action-menu');
              if (oldMenu) oldMenu.remove();

              const actions = this.actionmenu(params.data);

              const menu = document.createElement('div');
              menu.id = 'action-menu';

              menu.style.position = 'fixed';
              menu.style.background = '#fff';
              menu.style.borderRadius = '8px';
              menu.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
              menu.style.padding = '8px 0';
              menu.style.zIndex = '9999';
              menu.style.minWidth = '180px';

              actions.forEach(action => {
                const item = document.createElement('div');

                item.style.display = 'flex';
                item.style.alignItems = 'center';
                item.style.gap = '8px';
                item.style.padding = '8px 12px';
                item.style.cursor = 'pointer';

                const icon = document.createElement('i');
                icon.className = `mdi ${action.icon}`;

                const text = document.createElement('span');
                text.innerText = action.text;

                item.appendChild(icon);
                item.appendChild(text);

                item.addEventListener('click', () => {
                  this.performAction(action, params.data);
                  menu.remove();
                });

                item.addEventListener('mouseover', () => {
                  item.style.background = '#f5f5f5';
                });

                item.addEventListener('mouseout', () => {
                  item.style.background = '#fff';
                });

                menu.appendChild(item);
              });

              document.body.appendChild(menu);

              const rect = button.getBoundingClientRect();
              menu.style.top = rect.bottom + 'px';
              menu.style.left = rect.left + 'px';

              setTimeout(() => {
                const handler = () => {
                  menu.remove();
                  document.removeEventListener('click', handler);
                };
                document.addEventListener('click', handler);
              });

              const scrollHandler = () => {
                const existing = document.getElementById('action-menu');
                if (existing) existing.remove();
                window.removeEventListener('scroll', scrollHandler);
              };
              window.addEventListener('scroll', scrollHandler);
            });

            return button;
          },
        },
        {
          headerName: 'Helper Type Name',
          field: 'helpertype_title',
          flex: 1,
        },
        {
          headerName: 'Active Status',
          field: 'helpertype_isactive',
          width: 150,
        },
      ],

      gridOptions: {
        suppressRowClickSelection: true,
      },
    };
  },
  //this one will populate new data set when user changes current page.
  watch: {
    // currentPage() {
    //   this.readData();
    // },
    overlay(val) {
      val &&
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
    },
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
    },

    handlePageChange(value) {
      this.currentPage = value;
      this.readData();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.readData();
    },
    actionmenu(item) {
      const actionmenu = [
        { text: 'Edit', icon: 'mdi-pencil' },
        {
          text: item.helpertype_isactive == 'N' ? 'Activate' : 'Deactivate',
          icon:
            item.helpertype_isactive == 'N' ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off-outline',
        },
        { text: 'Delete', icon: 'mdi-delete' },
      ];

      return actionmenu;
    },
    performAction(action, item) {
      if (action.text == 'Edit') this.editItem(item);
      else if (action.text == 'Delete') this.deleteItem(item);
      else if (action.text == 'Activate' || action.text == 'Deactivate')
        this.ToggleHelperTypeActiveStatus(item.helpertype_id);
    },
    readData() {
      this.loading = true;
      DataService.getHelperType(this.currentPage, this.pageSize)
        .then(response => {
          this.helper_types = response.data.data;
          this.totalItems = response.data.total;
          this.loading = false;
          this.currentPage = response.data.current_page;
          this.lastPage = response.data.last_page;
        })
        .catch(e => {
          // console.log(e);
        });
    },
    ToggleHelperTypeActiveStatus(id) {
      DataService.HelperTypeActiveStatusToggle(id).then(response => {
        this.s('Helper-Type', 'Status has been updated successfully.');
        this.refreshList();
      });
    },
    HelperTypeDelete(id) {
      DataService.deleteHelperType(id).then(response => {
        this.s('Record Deleted');
        this.refreshList();
      });
    },
    openDialog() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.helper_types.helpertype_title = '';
      this.editedIndex = -1;
      this.errors = '';
    },
    closeDelete() {
      this.dialogDelete = false;
      this.editedIndex = -1;
    },
    deleteItem(item) {
      this.editedIndex = item.helpertype_id;
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.HelperTypeDelete(this.editedIndex);
      this.closeDelete();
    },

    save() {
      if (this.editedIndex > -1) {
        this.updateHelperType();
      } else {
        this.AddHelperType();
      }
    },
    refreshList() {
      this.readData();
    },
    editItem(item) {
      this.editedIndex = item.helpertype_id;
      this.helper_types.helpertype_title = item.helpertype_title;
      this.dialog = true;
      this.errors = '';
    },
    updateHelperType() {
      const data = new FormData();
      data.append('helpertype_title', this.helper_types.helpertype_title);
      DataService.updateHelperType(this.editedIndex, data)
        .then(response => {
          this.s('Helper Type', 'Record updated successfully!');
          this.close();
          this.refreshList();
        })
        .catch(error => {
          this.errors = error.response.data.error;
          this.e("Oop's", 'Something went wrong.');
        });
    },
    AddHelperType() {
      this.overlay = true;
      const data = new FormData();
      if (this.helper_types.helpertype_title == undefined) console.log('Blankk');
      else data.append('helpertype_title', this.helper_types.helpertype_title);

      DataService.createHelperType(data)
        .then(response => {
          this.s('Helper Type', 'Record Added Successfully!');
          this.close();
          this.refreshList();
        })
        .catch(error => {
          this.errors = error.response.data.error;
          this.overlay = false;
          this.e("Oop's", 'Something went wrong.');
        });
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
    },
  },
  mounted() {
    this.readData();
  },
};
</script>
<style>
.inputs-container {
  .col-12 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .theme--light.v-input {
    padding-top: 0;
  }
  .v-input__slot {
    margin-bottom: 0;
  }
}
</style>
<style scoped>
.body-margin {
  margin-top: -24px !important;
}
.search-field {
  margin-top: -48px !important;
}
.m-fix {
  margin-top: -14px;
}
.custom-title {
  padding: 8px 20px !important;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.fs {
  font-size: 18px !important;
  font-weight: 600 !important;
}
</style>

<style>
.menu-item {
  padding: 8px 10px;
  cursor: pointer;
}

.menu-item:hover {
  background: #f5f5f5;
}
</style>
